import { TreeSelect, type TreeSelectProps } from "antd"
import React from "react"

/** A picker over a project's folder tree, searched by folder name with every branch open. */
export function FolderTreeSelect(props: TreeSelectProps<string>) {
  return (
    <TreeSelect<string>
      showSearch
      treeDefaultExpandAll
      // The default filter matches `value`, which is the folder's id.
      treeNodeFilterProp="title"
      className="w-full"
      {...props}
    />
  )
}
